<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";

const {darkMode} = storeToRefs(useNamaFlagsStore());
const props = defineProps({
  height: {type: Number, required: true}
});
</script>

<template>
  <q-card-actions class="tw-justify-center">
    <q-skeleton type="QToolbar" :dark="darkMode" class="tw-w-full" :style="{height:height+'px'}"/>
  </q-card-actions>
</template>

<style scoped>

</style>
